var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMakeShorten = function SvgMakeShorten(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 13,
    fill: "currentColor",
    style: {
      color: "#2d4e6d"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.668 7a.667.667 0 0 0 0 1.333h1.057L.863 11.195a.667.667 0 0 0 .943.943l2.862-2.862v1.057a.667.667 0 1 0 1.333 0V7.667A.667.667 0 0 0 5.334 7H2.668ZM9.1 3.05V1.991a.667.667 0 0 0-1.333 0v2.666a.667.667 0 0 0 .667.667H11.1a.667.667 0 1 0 0-1.333h-1.057l2.862-2.862a.667.667 0 0 0-.943-.943L9.1 3.05Z"
  })));
};
export default SvgMakeShorten;